import { useCallback, useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import Token from '../interfaces/Token.ts'

import { makeUrlToken } from './connectionData.tsx'

const useTokenFetcher = () => {
  const [errorFetchToken, setErrorFetchToken] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchToken = useCallback(async (_id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlToken(_id)
      const res = await customFetch<Token>(apiUrl)

      setErrorFetchToken(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorFetchToken(err)
      } else {
        setErrorFetchToken(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }, [])

  // Exponemos estas variables al exterior
  return { errorFetchToken, loading, fetchToken }
}
export default useTokenFetcher
